(function(angular, module) {var dybFormController, dybFormDirective,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  hasProp = {}.hasOwnProperty;

dybFormController = (function() {

  /* @ngInject */
  function dybFormController($q, $element, $scope, $attrs, $parse, $transclude) {
    var exp;
    this.$q = $q;
    this.$element = $element;
    this.$scope = $scope;
    this.$attrs = $attrs;
    this.close = bind(this.close, this);
    this.open = bind(this.open, this);
    this.watchEditable = bind(this.watchEditable, this);
    this.watchOpen = bind(this.watchOpen, this);
    this.scope = this.$scope;
    this.ngForm = this.$element.controller('form');
    this.controls = {};
    this.formData = {};
    this.isOpen = false;
    this.pickClass(false, "open", "closed");
    this.$element.attr('novalidate', 'novalidate');
    if (this.$attrs.startOpen != null) {
      this.isOpen = $parse(this.$attrs.startOpen)(this.scope.$parent);
    }
    this.scope.$watch('open', (function(_this) {
      return function(v) {
        return _this.watchOpen(v);
      };
    })(this));
    this.scope.$watch('editable', this.watchEditable);
    if (this.$attrs.dybForm) {
      exp = $parse(this.$attrs.dybForm);
      exp.assign(this.scope.$parent, this);
    }
  }

  Object.defineProperties(dybFormController.prototype, {
    isOpen: {
      get: function() {
        return !!this._isOpen;
      },
      set: function(value) {
        var newState, oldState;
        newState = !!value && this.isEditable;
        oldState = this._isOpen;
        if (oldState !== newState) {
          if (newState) {
            return this.open();
          } else {
            return this.close();
          }
        }
      }
    },
    isEditable: {
      get: function() {
        return this.$scope.editable;
      },
      set: function(value) {
        return this.$scope.editable = !!value;
      }
    }
  });

  dybFormController.prototype.addControl = function(control) {
    this[control.name] = control;
    this.controls[control.name] = control;
  };

  dybFormController.prototype.removeControl = function(control) {
    delete this.controls[control.name];
    delete this[control.name];
  };

  dybFormController.prototype.getFormData = function(control) {
    return this.formData[control.name];
  };

  dybFormController.prototype.setFormData = function(control, value) {
    return this.formData[control.name] = value;
  };

  dybFormController.prototype.controlNames = function() {
    return Object.keys(this.controls);
  };

  dybFormController.prototype.pickClass = function(value, trueClass, falseClass) {
    this.$element.toggleClass(trueClass, !!value);
    this.$element.toggleClass(falseClass, !value);
    return void 0;
  };

  dybFormController.prototype.watchOpen = function(value) {
    this.isOpen = value;
  };

  dybFormController.prototype.watchEditable = function(value) {
    return this.pickClass(value, "editable", "locked");
  };

  dybFormController.prototype.refreshFormData = function() {
    var control, name, ref;
    ref = this.controls;
    for (name in ref) {
      if (!hasProp.call(ref, name)) continue;
      control = ref[name];
      control.refreshData();
    }
    this.onRefresh();
  };

  dybFormController.prototype.open = function() {
    var openPromise;
    if (this.isOpen) {
      return this.$q.reject('already open');
    }
    openPromise = this.$q.when(this.onOpen({
      dybForm: this
    }));
    return openPromise.then((function(_this) {
      return function() {
        var base;
        _this.pickClass(true, "open", "closed");
        _this.refreshFormData();
        _this.scope.open = true;
        _this._isOpen = true;
        return typeof (base = _this.scope).$broadcast === "function" ? base.$broadcast('elastic:adjust') : void 0;
      };
    })(this));
  };

  dybFormController.prototype.close = function() {
    var closePromise;
    if (!this.isOpen) {
      return this.$q.reject("already closed");
    }
    closePromise = this.$q.when(this.onClose({
      dybForm: this
    }));
    return closePromise.then((function(_this) {
      return function() {
        _this.pickClass(false, "open", "closed");
        _this.refreshFormData();
        _this.scope.open = _this._isOpen = false;
        return _this.$q.when(_this.afterClose());
      };
    })(this));
  };

  dybFormController.prototype.save = function() {
    var context;
    this.ngForm.$commitViewValue();
    context = {
      data: angular.copy(this.formData),
      ngForm: this.ngForm,
      dybForm: this
    };
    return this.$q.when(this.onSave(context));
  };

  dybFormController.prototype.saveSuccess = function(result) {
    return this.close().then((function(_this) {
      return function() {
        return _this.afterSave({
          result: result
        });
      };
    })(this));
  };

  dybFormController.prototype.saveError = function() {};

  dybFormController.prototype.toJSON = function() {
    var control, json, name, ref;
    json = {
      isOpen: this.isOpen,
      isEditable: this.isEditable
    };
    ref = this.controls;
    for (name in ref) {
      control = ref[name];
      json[name] = control;
    }
    return json;
  };

  return dybFormController;

})();

dybFormDirective = function() {
  return {
    restrict: 'A',
    templateUrl: 'forms/form',
    require: 'form',
    transclude: {
      extraButtons: '?extraButtons'
    },
    scope: {
      open: '=?formOpen',
      editable: '=?formEditable'
    },
    controllerAs: 'ctrl',
    controller: dybFormController,
    bindToController: {
      onOpen: '&',
      onClose: '&',
      onSave: '&',
      onRefresh: '&',
      afterSave: '&',
      afterClose: '&'
    },
    link: function(scope, element) {
      return element.addClass('dyb-form');
    }
  };
};

module.directive("dybForm", dybFormDirective);
})(angular, angular.module("dybForms"));